// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2OHus","inner":"Form_inner__2Ov44","range":"Form_range__2YqJm","name":"Form_name__3SBJp","actions":"Form_actions__1E3_h"};